import { render, staticRenderFns } from "./JgpAlert.vue?vue&type=template&id=1ebf71f8&"
import script from "./JgpAlert.vue?vue&type=script&lang=js&"
export * from "./JgpAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports